module.exports = {
  ["Win Go"]: "Win Go",
  ["K3 Lotre"]: "快三",
  ["大"]: "大",
  ["小"]: "小",
  ["单"]: "单",
  ["双"]: "双",
  ["奇"]: "奇",
  ["偶"]: "偶",
  ["2个匹配的数字: 赔率"]: "2个匹配的数字: 赔率",
  ["一对不同的数字: 赔率"]: "一对不同的数字: 赔率",
  ["三个相同数字: 赔率"]: "三个相同数字: 赔率",
  ["任意三个相同数字：赔率"]: "任意三个相同数字：赔率",
  ["任意三个相同数字"]: "任意三个相同数字",
  ["3个不同的数字:赔率 "]: "3个不同的数字:赔率 ",
  ["3个连续数字:赔率 "]: "3个连续数字:赔率 ",
  ["3个连续数字"]: "3个连续数字",
  ["2个不同的数字:赔率"]: "2个不同的数字:赔率",
  ["无效号码"]: "无效号码",
  ["二同号 (对子)"]: "二同号 (对子)",
  ["三同号 (豹子)"]: "三同号 (豹子)",
  ["三连号 (顺子)"]: "三连号 (顺子)",
  ["三不同号 (散号)"]: "三不同号 (散号)",
  ["购彩详情"]: "购彩详情",
  ["Game history"]: "开奖记录",
  ["Chart"]: "图表趋势",
  ["My history"]: "购彩历史",
  ["Period"]: "期号",
  ["Sum"]: "总和",
  ["Results"]: "结果",
  ["Number"]: "数字",
  ["Total"]: "总和",
  ["Statistic (last 100 Periods)"]: "统计 (过去100期)",
  ["Missing"]: "多少期没开",
  ["Avg missing"]: "平均多少期没开",
  ["Frequency"]: "出现的频率",
  ["Max consecutive"]: "最大连开期数",
  ["Stake"]: "Stake",
  ["Valid Stake"]: "Valid Stake",
  ["Big"]: "大",
  ["Small"]: "小",
  ["Odd"]: "奇",
  ["Even"]: "偶",
  ["Balance"]: "金额",
  ["Quantity"]: "数量",
  ["2个匹配数字"]: "2个匹配数字",
  ["一对独特的数字"]: "一对独特的数字",
  ["3个相同数字"]: "3个相同数字",
  ["任意3个相同的数字"]: "任意3个相同的数字",
  ["任意3个相同"]: "任意3个相同",
  ["3个不同的数字"]: "3个不同的数字",
  ["3个连续的数字"]: "3个连续的数字",
  ["2个不同的数字"]: "2个不同的数字",
  ["无效号码"]: "无效号码",
  ["二同号 (对子)"]: "二同号 (对子)",
  ["三同号 (豹子)"]: "三同号 (豹子)",
  ["三连号 (顺子)"]: "三连号 (顺子)",
  ["三不同号 (散号)"]: "三不同号 (散号)",
  ["Total amount Rp"]: "总金额",
  ["可用余额"]: "可用余额",
  ["Cancel"]: "取消",
  ["Green"]: "绿色",
  ["Violet"]: "紫色",
  ["Red"]: "红色",
  ["How to Play"]: "玩法说明",
  ["Select"]: "选择",
  ["Big Small"]: "大小",
  ["Color"]: "颜色",
  ["Statistic (last 100 Periods)"]: "开奖号码 (间隔100期)",
  ["Winning number"]: "开奖号码",
  ["racing"]: "赛车",
  ["Random"]: "随机",
  ["All"]: "全部",
  ["Clean"]: "清空",
  ["P1~P5"]: "P1~P5",
  ["P6~P10"]: "P6~P10",
  ["Two-Sided Statistics"]: "双面统计",
  ["Basic Trend"]: "基本走势",
  ["Champion"]: "冠军",
  ["Runner-up"]: "亚军",
  ["Third place"]: "季军",
  ["4th place"]: "第四名",
  ["5th place"]: "第五名",
  ["6th place"]: "第六名",
  ["7th place"]: "第七名",
  ["8th place"]: "第八名",
  ["9th place"]: "第九名",
  ["10th place"]: "第十名",
  ["First+Second sum"]: "冠亚和",
  ["Champion Trend"]: "冠军走势",
  ["Runner-up Trend"]: "亚军走势",
  ["Third place Trend"]: "季军走势",
  ["P/L"]: "盈亏",
  ["Awaiting Draw"]: "等待开奖",
  ["No."]: "编号",
  ["Today"]: "今天",
  ["Yesterday"]: "昨天",
  ["This Week"]: "本周",
  ["All States"]: "全部状态",
  ["Won"]: "赢",
  ["Lost"]: "输",
  ["All Types"]: "全部类型",
  ["Type A"]: "类型A",
  ["Type B"]: "类型B",
  ["Max missing"]: "最大遗漏",
  ["First"]: "第一名",
  ["Second"]: "第二名",
  ["Third"]: "第三名",
  ["Fourth"]: "第四名",
  ["Fifth"]: "第五名",
  ["Sixth"]: "第六名",
  ["Seventh"]: "第七名",
  ["Eighth"]: "第八名",
  ["Ninth"]: "第九名",
  ["Tenth"]: "第十名",
  ["Top"]: "前",
  ["Last"]: "后",
  ["SUM 1&2:"]: "总和1&2:",
  ["SUM 1&2"]: "总和1&2",
  ["big-odd"]: "大-单",
  ["big-even"]: "大-双",
  ["Small-odd"]: "小-单",
  ["Small-even"]: "小-双",
  ["Position"]: "位置",
  ["今天"]: "今天",
  ["昨天"]: "昨天",
  ["本周"]: "本周",
  ["全部状态"]: "全部状态",
  ["待开奖"]: "待开奖",
  ["已开奖"]: "已开奖",
  ["已撤单"]: "已撤单",
  ["全部开奖"]: "全部开奖",
  ["未中奖"]: "未中奖",
  ["已中奖"]: "已中奖",
  ["温馨提示"]: "温馨提示",
  [""]: "",
  [""]: "",
  [""]: "",
  [""]: "",
  [""]: "",
  [""]: "",
  [""]: "",
  [""]: "",
  [""]: "",
  [""]: "",
  [""]: "",
  [""]: "",
};
